import Folders from '@/apiClient/Folders'
const Lo = require('lodash')
const folders = new Folders()

const actions = {
    getListFoldersAvailable: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            folders.getFoldersSettingsAvailable(payload).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e.response.data)
            })
        })
    },
    getListSubFoldersAvailable: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            folders.getSubFoldersAvailableForId(payload).then(response => {
                resolve(response.data)
            }).catch(e => {
                reject(e.response.data)
            })
        })
    },
    updateSubFolder: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            folders.updateSubFolder(payload).then(response => {
                resolve(response.data)
            }).catch( e => {
                reject(e.response.data)
            })
        })
    },
    deleteSubFolder: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            folders.deleteSubFolder(payload).then( response => {
                resolve(response)
            }).catch(e => {
                reject(e.response.data)
            })
        })
    },
    createSubFolder: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            folders.createSubFolder(payload).then( response => {
                resolve(response)
            }).catch( e => {
                reject(e.response.data)
            })
        })
    },
    getTemplateSubFolders: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            folders.getTemplateSubFolders(payload).then( response => {
                let listTemplate = Lo.map(response.data.data, item => {
                    return { key:item.id, value: `${item.json.max_files} Hojas | ${item.json.min_files} Obligatorias` }
                })
                resolve(listTemplate)
            }).catch(e => {
                reject(e.response.data)
            })
        })
    },
    getApplicationParser: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            folders.getApplicationParser().then(response => {
                let listResponse = Lo.map(response.data.data, (parser: any) => {
                    return Lo.omitBy(parser, function (value) {
                        return Lo.isEmpty(value) || Lo.isNil(value)
                    })
                })
                const listParser = Lo.filter(listResponse, (parser: any) => {
                    return !Lo.isEmpty(parser)
                })
                listParser.push({
                    parser: '',
                    alias: 'Metodo de captura vacio'
                })
                resolve(Lo.sortBy(listParser, ['parser']))
            }).catch(e => {
                reject(e.response.data)
            })
        })
    }
}

export default actions